// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 30vw;
  height: 60vh;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  /* overflow: hidden; */
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

.chat-container-max {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 99vw;
  height: 95vh;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  /* overflow: hidden; */
  z-index: 9999;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

.chat-header {
  background-color: #4bb3bc;
  color: white;
  padding: 10px;
  text-align: center;
}

.chat-body {
  padding: 10px;
  color: #000;
  font-family: "Inter", "San Francisco", ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px;
  /* background-color: #4BB3BC;
  color: white;
  border: none; */
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/AppLayout/Footer/index.css"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,uCAAA;EACA,sBAAA;EACA,2BAAA;EACA,sCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,uCAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,sCAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,oJAAA;EAEA,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA;;iBAAA;EAGA,eAAA;AAAJ","sourcesContent":[".chat-container {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    width: 30vw;\n    height: 60vh;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    /* overflow: hidden; */\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n}\n\n.chat-container-max {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 99vw;\n    height: 95vh;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    /* overflow: hidden; */\n    z-index: 9999;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n}\n\n.chat-header {\n    background-color: #4bb3bc;\n    color: white;\n    padding: 10px;\n    text-align: center;\n}\n\n.chat-body {\n    padding: 10px;\n    color: #000;\n    font-family: 'Inter', 'San Francisco', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans',\n        sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.5;\n}\n\n.toggle-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    padding: 10px;\n    /* background-color: #4BB3BC;\n    color: white;\n    border: none; */\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
